const palette = {
  light: {
    primary: {
      main: "#0E7490",
      dark: "#155E75",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#7C3AED",
      dark: "#6D28D9",
    },
    success: { main: "#2E7D32" },
    error: { main: "#D32F2F" },
    text: { secondary: "rgba(0, 0, 0, 0.6)" },
    background: {
      default: "#F3F7FB",
      paper: "#FFFFFF",
      chat: "#EEF4F8",
    },
    action: { selected: "rgba(14, 116, 144, 0.12)" },
    cards: { background: "#FFF" },
    appBar: { background: "#07111F" },
    scrollbar: { thumb: "rgba(0,0,0,.1)" },
    userMessage: { main: "#D7F3FA" },
    contactMessage: { main: "#FFFFFF" },
    timestamp: { background: "#E8EEF5" },
    queue: { fallback: "#7C7C7C" },
  },
  dark: {
    primary: {
      main: "#2EC8E6",
      dark: "#22A8C4",
      contrastText: "#07111F",
    },
    secondary: {
      main: "#A855F7",
      dark: "#9333EA",
    },
    success: { main: "#66BB6A" },
    error: { main: "#F44336" },
    background: {
      default: "#07111F",
      paper: "#0D1B2A",
      chat: "#050B14",
    },
    action: { selected: "rgba(46, 200, 230, 0.16)" },
    cards: { background: "#122033" },
    appBar: { background: "#050B14" },
    scrollbar: { thumb: "hsla(0,0%,100%,.16)" },
    userMessage: { main: "#134E5E" },
    contactMessage: { main: "#122033" },
    timestamp: { background: "#0D1B2A" },
    queue: { fallback: "#7C7C7C" },
  },
};

export default palette;
